enum DateFormats {
  DEFAULT_DATE_FORMAT = 'dd MMMM yyyy',
  ADMIN_DATE_FORMAT = 'MMM dd yyyy',
  DATE_SLASH_FORMAT = 'dd/MM/yy',
  DEFAULT_TIME_FORMAT = 'h:mmaaa'

}

export default DateFormats;
